module.exports = "/img/videos/1.c422a5.mp4";